import { useBeforeUnload, useLocation } from 'react-router-dom'
import React, { useEffect } from 'react'

/**
 * Using react router we create an effect when the page was loaded and when the page was unloaded
 * @param onLoad - the event to run when the page loads
 * @param onUnload - the event to run when the page unloads
 */

export const usePageLifecycle = (onLoad: () => void, onUnload: () => void) => {
  const location = useLocation()

  useEffect(() => {
    if (onLoad) onLoad() // Run when the page loads
    return () => {
      if (!onUnload) return
      return onUnload() //when the user navigated away
    }
  }, [location.pathname]) // Runs when the route changes

  useBeforeUnload(
    React.useCallback(() => {
      if (!onUnload) return
      return onUnload()
    }, [])
  )
}
